import { render, staticRenderFns } from "./warningConfig.vue?vue&type=template&id=2c068fb9&scoped=true&"
import script from "./warningConfig.vue?vue&type=script&lang=js&"
export * from "./warningConfig.vue?vue&type=script&lang=js&"
import style0 from "./warningConfig.vue?vue&type=style&index=0&id=2c068fb9&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c068fb9",
  null
  
)

export default component.exports